// extracted by mini-css-extract-plugin
export var brand = "_4m-9";
export var compact = "_4m-6";
export var extraSmall = "_4m-7";
export var icon = "_4m-0";
export var large = "_4m-4";
export var light = "_4m-1";
export var medium = "_4m-5";
export var outline = "_4m-b";
export var primaryDark = "_4m-a";
export var primaryLight = "_4m-8";
export var primaryModern = "_4m-c";
export var success = "_4m-2";
export var successSolid = "_4m-3";